import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

// Visible Breadcrumbs trail
// Pairs with SEO breadcrumbs prop for both UI and BreadcrumbList schema.
// Props: items: [{ name, url }]
const Breadcrumbs = ({ items = [] }) => {
  if (!items.length) return null;
  return (
    <nav
      data-testid="breadcrumbs"
      aria-label="Breadcrumb"
      className="flex flex-wrap items-center gap-1.5 font-mono-data text-[11px] uppercase tracking-wider text-platinum-2"
    >
      {items.map((b, i) => {
        const last = i === items.length - 1;
        return (
          <React.Fragment key={b.url + i}>
            {last ? (
              <span aria-current="page" className="text-gold">{b.name}</span>
            ) : (
              <Link to={b.url} className="hover:text-gold underline-offset-2 hover:underline transition-colors">{b.name}</Link>
            )}
            {!last && <ChevronRight size={11} strokeWidth={1.5} className="text-muted-warm" />}
          </React.Fragment>
        );
      })}
    </nav>
  );
};

export default Breadcrumbs;
